import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";

const detectionOptions = {
    caches: ['cookie'],
    cookieSameSite: 'strict',
    lookupQuerystring: 'lang', // default is lng
    lookupCookie: 'next-i18next',
    order: ['querystring', 'cookie', 'header'], // IMPORTANT
}

const getCookie = (name: string) => {
    const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split("=").slice(1).join("=")) : undefined;
}

const languageDetector = {
    type: "languageDetector" as const,
    init() {},
    detect() {
        const fromQuery = new URLSearchParams(window.location.search).get(
            detectionOptions.lookupQuerystring
        );
        if (fromQuery) return fromQuery;

        const fromCookie = getCookie(detectionOptions.lookupCookie);
        if (fromCookie) return fromCookie;

        return navigator.language || navigator.languages?.[0] || "en";
    },
    cacheUserLanguage(lng: string) {
        if (!detectionOptions.caches.includes("cookie")) return;
        document.cookie = `${detectionOptions.lookupCookie}=${encodeURIComponent(lng)}; path=/; SameSite=${detectionOptions.cookieSameSite}`;
    },
}

const resources = {
    en,
    es,
}

i18n
.use(languageDetector)
.use(initReactI18next)
.init({
    resources,
    detection: detectionOptions,
    defaultNS: "header",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
